const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/selectors/deviceSelectors.ts';
import { createSelector } from 'reselect';
import { IReliableDeviceInfo } from '@cistec/common/shared_defs';
import { ReducerState } from '../defs/actionTypes';
import { CommonStoreState } from '../reducers';
import { DeviceOrientation, DeviceType } from '@cistec/common_web/defs/device';

export const selectReducerState = (state: CommonStoreState): ReducerState => state.device;

export const selectDeviceInfo = createSelector(
    [selectReducerState],
    (state: ReducerState): IReliableDeviceInfo => state.toJS()
);
export const selectDeviceType = (state: CommonStoreState): DeviceType => state.device.get('type');
export const selectDeviceOrientation = (state: CommonStoreState): DeviceOrientation => state.device.get('orientation');
export const selectDeviceWidth = (state: CommonStoreState): number => state.device.get('width');
export const selectDeviceHeight = (state: CommonStoreState): number => state.device.get('height');
export const selectDeviceOS = (state: CommonStoreState): string => state.device.get('os');
export const selectDeviceVersion = (state: CommonStoreState): string | null => state.device.get('osVersion');
export const selectBuildNumber = (state: CommonStoreState): string | null => state.device.get('buildNumber');

/**
 * Returns the length of the shortest side of the device, i.e. width in portrait mode and height in landscape mode respectively. This
 * value can be used to compare with the breakpoints to define the layout (according to GMD the breakpoints are for the "the smallest
 * width in either orientation".
 */
export const selectDeviceSmallestWidth = createSelector(
    [selectDeviceHeight, selectDeviceWidth],
    (height, width): number => (width < height ? width : height)
);

// returns for example iOS_12
export const deviceOSAndVersion = createSelector(
    [selectDeviceOS, selectDeviceVersion],
    (OS: string, version: string) => {
        return OS + '_' + version?.split('_')?.[0];
    }
);
